<template lang="html">
 <div class="signup container">
     <h2 class="center light-blue-text">Ajouter un utilisateur</h2>
     <form @submit.prevent="signup" class="card-panel">
         <div class="input-field">
             <label for="email">Email:</label>
             <input type="email" name="email" class="validate" v-model="email">
         </div>
         <div class="input-field">
             <label for="password">Mot de passe:</label>
             <input type="password" name="password" v-model="password">
         </div>
         <div class="input-field">
             <label for="alias">Nom d'utilisateur:</label>
             <input type="text" name="alias" v-model="alias">
         </div>
         <div class="input-field">
             <label for="last_name">Nom:</label>
             <input type="text" name="last_name" v-model="last_name">
         </div>
         <div class="input-field">
             <label for="first_name">Prénom:</label>
             <input type="text" name="first_name" v-model="first_name">
         </div>
         <div class="input-field">
             <label for="service">Service:</label>
             <input type="text" name="service" v-model="service">
         </div>
         <div class="input-field">
             <label for="phone">Téléphone:</label>
             <input type="text" name="phone" v-model="phone">
         </div>
         <!-- <div class="input-field">
             <label for="mobile">Téléphone mobile:</label>
             <input type="text" name="mobile" v-model="mobile">
         </div> -->
         <p class="red-text center" v-if="feedback">{{feedback}}</p>
         <div class="input-field center">
             <button class="btn light-blue">Ajouter</button>
         </div>
     </form>
 </div>
</template>

<script>
import slugify from 'slugify'
import db from '@/firebase/init'
import firebase from 'firebase'

export default {
    name: 'signup',
    data(){
        return{
            alias: null,
            first_name: null,
            last_name: null,
            email: null,
            password: null,
            feedback: null,
            role: null,
            phone: null,
            // mobile: null,
            service: null,
            active: true
        }
    },
    methods: {
        signup(){
            if(this.alias && this.email && this.password){
                //create slug
                this.slug = slugify(this.alias, {
                    replacement: '-',
                    remove: /[$*_+~.['"!\-:@]/g,
                    lower: true
                })
                //check db for this alias
                let ref = db.collection('users').doc(this.slug)
                ref.get().then(doc => {
                    if(doc.exists){
                        this.feedback = "Désolé, ce nom d'utilisateur est déjà utilisé"
                    }else{
                        firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
                        .then(cred => {
                            ref.set({
                                alias: this.alias,
                                first_name: this.first_name,
                                last_name: this.last_name,
                                slug: this.slug,
                                user_id: cred.user.uid,
                                role: 'user',
                                phone: this.phone,
                                // mobile: this.mobile,
                                service: this.service,
                                email: cred.user.email,
                                password: this.password,
                                active: true
                            })
                        })
                        .then(() => {
                            //redirect after create
                            this.$router.push({ name: 'Admin' })
                        })
                        .catch(err => {
                            console.log(err)
                            this.feedback = err.message
                        })
                        this.feedback = "Ce nom d'utilisateur est disponible, profil en cours de création"
                    }
                })
            }else{
                this.feedback = "Vous devez compléter tous les champs pour ajouter un utilisateur"
            }

        }
    }
}
</script>

<style lang="css" scoped>
    .signup{
        max-width: 800px;
        margin-top: 60px;
    }
    .signup h2{
        font-size: 2.2em;
    }
    .signup.input-field{
        margin-bottom: 16px;
    }
</style>
